import { Endpoint, IeAnexo, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { DeckAPI, FieldAPI } from '@philips-emr/tws-components';
import Controller, { OnMount, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { MountEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { isEmptyObject, isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { FragmentNames } from '../codegen';
import { DossieContratoDocumentosAliases as Aliases } from '../codegen/constants/aliases/dossie-contrato-documentos-aliases';

import BaseController from './BaseController';

interface Documento {
  nrSeqDoc: number,
  dsArquivo: string,
}

@Controller({ fragment: FragmentNames.DOSSIE_CONTRATO_DOCUMENTOS })
export default class DossieContratoDocumentos extends BaseController {

  @OnSelectItem(Aliases.DECK_DOSSIE)
  onClickDownloadDocumento(event: SelectItemEvent<any>): void {
    const { nrSeqDoc, dsArquivo } = event.item as Documento;
    const api = event.target as DeckAPI;
    api.unselectAll();
    this.downloadDocumento(nrSeqDoc, dsArquivo);
  }

  @OnSelectItem(Aliases.DECK_RESPONSIVO)
  onClickDownloadDocumentoResponsivo(event: SelectItemEvent<any>): void {
    const { nrSeqDoc, dsArquivo } = event.item as Documento;
    const api = event.target as DeckAPI;
    api.unselectAll();
    this.downloadDocumento(nrSeqDoc, dsArquivo);
  }

  @OnMount(Aliases.FIELD_OBSERVACAO_RESPONSIVO)
  onMountObservacaoResponsivo(event: MountEvent): void {
    const api = event.target as unknown as FieldAPI;
    const data = api.getData();

    if (isEmptyObject(data) || isEmptyOrBlankString((data as any).dsObservacao)) {
      api.setVisible(false);
    }
  }

  private downloadDocumento = (nrSeqDoc: number, dsArquivo: string): void => {

    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const ieTabela = IeAnexo.DOSSIE_CONTRATO_DOCUMENTO;

    ToastServiceStipulator.information(MessageService.translate('beneficiario.download-iniciado'));
    FileService.download(Endpoint.GET.DOWNLOAD_DOCUMENTOS, dsArquivo, { ieTabela, nrSeqDoc, nrSeqContrato }, HttpMethod.GET)
      .catch(() => {
        ToastServiceStipulator.close();
        ToastServiceStipulator.error(MessageService.translate('stipulator.arquivo-nao-localizado'));
      });

  };

}
